import React from "react";
import { PageLayout } from "../common/layout";
import { ComingSoon } from "../common/components";

// Página custom. Llenala en develop; el merge base→develop preserva tus cambios.
export const IdasPage = () => {
  return (
    <PageLayout>
      <ComingSoon
        title="IDAs"
        description="Informes de Actuación: obras ejecutadas en vivo o difundidas, para su correcta liquidación."
      />
    </PageLayout>
  );
};
